import { ViewStyle, Platform } from 'react-native'
import { createUseStyles } from '../../styles/create-use-styles'
import { ButtonProps } from './button.props'
import { getColorVariants } from './util/get-color-variants'

interface ButtonStyles {
  container: ViewStyle
  pressable: ViewStyle
  contentContainer: ViewStyle
  icon: ViewStyle
  iconHover: ViewStyle
}

export const useStyles = createUseStyles<ButtonStyles, ButtonProps>((theme, props): ButtonStyles => {
  const { disabled, isLoading, minWidth, size = 'md', variant = 'primary' } = props
  let paddingVertical = theme.calcUnit(theme.spacing.s4)
  let paddingHorizontal = theme.calcUnit(theme.spacing.s4)
  const { bg, border } = getColorVariants(theme, variant, isLoading)
  if (size === 'sm') {
    paddingVertical = theme.calcUnit(theme.spacing.s2)
    paddingHorizontal = theme.calcUnit(theme.spacing.s3)
  }

  return {
    container: {
      elevation: 8,
      backgroundColor: bg,
      borderColor: border,
      borderWidth: theme.calcUnit(1),
      borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      overflow: 'hidden',
      minWidth,
      opacity: disabled ? 0.4 : theme.opacity.opaque,
    },
    pressable: {
      display: 'flex',
      flex: 1,
      paddingVertical,
      paddingHorizontal,
      alignItems: 'center',
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    icon: {
      marginLeft: theme.calcUnit(theme.spacing.s2),
      ...Platform.select({
        web: {
          transition: 'transform .3s ease',
        },
      }),
    },
    iconHover: {
      ...Platform.select({
        web: {
          transform: 'translateX(5px)',
        },
      }),
    },
  }
})
